import React, { useState } from 'react';
import { Icon, Spinner } from 'ui';
import cn from 'classnames';

const Title = ({ title, isLoading }) => {
  const icon = isLoading ? (
    <Spinner className="Icon" />
  ) : (
    <Icon className="Icon" name="edit" />
  );
  return (
    <>
      {icon}
      {title}
    </>
  );
};

const DisabledWrapperTitle = ({ tooltipText, className, children }) => {
  return (
    <span
      className={cn('PanelToolbar-link PanelToolbar-disabled', className)}
      data-toggle="tooltip"
      data-original-title={tooltipText}
    >
      {children}
    </span>
  );
};

const LessonToolbarEditLink = ({ url, isNew, isDraft }) => {
  const [isLoading, setIsLoading] = useState(false);

  let title;
  if (isNew) {
    title = t('drafts.new_draft');
  } else if (isDraft) {
    title = t('drafts.edit_draft');
  } else {
    title = t('actions.edit');
  }

  if (isLoading) {
    return (
      <DisabledWrapperTitle
        className="PanelToolbar-loading"
        tooltipText={t('drafts.loading')}
      >
        <Title title={title} isLoading />
      </DisabledWrapperTitle>
    );
  }
  if (!url) {
    return (
      <DisabledWrapperTitle tooltipText={t('archive.uneditable')}>
        <Title title={title} />
      </DisabledWrapperTitle>
    );
  }

  return (
    <a
      className="PanelToolbar-link"
      href={url}
      onClick={() => setIsLoading(true)}
    >
      <Title title={title} />
    </a>
  );
};

export default LessonToolbarEditLink;
